import { Criterion } from "./criterion.model";

export class ProductDisplayRequest {
    pageSize:number;
    pageNumber:number;
    criteria:Criterion[];
}